var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 12,
    viewBox: "0 0 37 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.72421C0 8.80351 0.798853 8.08636 1.71422 8.18532L30.1637 11.2609C33.6717 11.6402 36.6285 8.67298 36.2369 5.16633C35.8336 1.55539 32.1094 -0.6855 28.7302 0.649534L2.11659 11.1638C1.10075 11.5651 0 10.8165 0 9.72421Z",
    fill: "url(#paint0_linear_2164_71)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2164_71",
    x1: 136.358,
    y1: 7.62354,
    x2: 122.281,
    y2: 52.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF8908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B415FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavUnderline);
export default __webpack_public_path__ + "static/media/nav_underline.c56cde277213bbba5816c05ee4d24f73.svg";
export { ForwardRef as ReactComponent };